import { render } from "./school.vue?vue&type=template&id=1d5d849a"
import script from "./school.vue?vue&type=script&lang=js"
export * from "./school.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__